var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTempusLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 50,
    viewBox: "0 0 303 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 303,
    height: 50,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5513 36.0786V46.0315H58.0402V3.94385H94.1948V13.8357H70.1507V19.6199H92.3542V29.756H70.1507V36.073L94.5513 36.0786Z",
    fill: "#01000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.898 3.94385V46.0315H146.907V23.4945L138.301 46.0315H124.941L116.332 23.4945V46.0315H104.34V3.94385H120.547L131.648 32.3844L142.75 3.94385H158.898Z",
    fill: "#01000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.523 33.217H181.21V46.0315H169.099V3.94385H189.581C201.216 3.94385 207.628 9.07297 207.628 18.5513C207.628 28.0296 201.158 33.217 189.523 33.217ZM189.76 13.8357H181.21V23.2724H189.879C193.677 23.2724 195.28 22.0817 195.28 18.5541C195.28 15.0264 193.558 13.8357 189.76 13.8357Z",
    fill: "#01000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.518 3.94385H227.629V28.0324C227.608 30.2564 228.341 32.4213 229.707 34.1718C231.072 35.962 233.446 36.8557 236.713 36.8557C240.029 36.8557 242.412 35.962 243.777 34.1718C245.143 32.4213 245.876 30.2564 245.855 28.0324V3.94385H257.968V27.1359C257.968 33.9341 256.009 38.9429 252.09 42.1625C248.221 45.3821 243.067 46.9919 236.716 46.9919C230.365 46.9919 225.196 45.3821 221.338 42.1625C217.48 38.9429 215.521 33.9331 215.521 27.1359L215.518 3.94385Z",
    fill: "#01000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.821 33.3973C271.013 34.432 273.299 35.251 275.648 35.8425C278.232 36.4829 280.882 36.8228 283.544 36.8555C288.355 36.8555 290.729 36.0784 290.729 34.5297C290.729 32.8005 288.175 31.9679 283.485 31.0131C282.722 30.9157 281.968 30.756 281.23 30.5357C271.375 28.2709 265.853 25.5398 265.676 16.3446C265.676 11.8733 267.456 8.53435 271.079 6.3306C274.702 4.12685 279.39 3 285.146 3C291.144 3 297.859 4.49044 302.66 7.05501L298.791 15.9366C294.457 14.2075 288.877 13.1944 284.84 13.1944C280.387 13.1944 277.895 14.1492 277.895 15.8173C277.895 17.5464 280.269 18.2625 284.602 19.0368L286.324 19.3949C291.608 20.5273 295.704 22.0788 298.614 24.1632C301.521 26.1921 303.005 29.2313 303.005 33.2863C303.005 37.8769 301.165 41.3352 297.478 43.6C293.791 45.8648 288.991 47 283.054 47C279.745 46.9956 276.451 46.5543 273.257 45.6872C269.941 44.7935 267.083 43.6611 264.77 42.2289L268.821 33.3973Z",
    fill: "#01000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35879 3.94385H0V13.7774H5.35879V3.94385Z",
    fill: "#01000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9971 3.94385H8.20538V13.7774H17.9971V3.94385Z",
    fill: "#01000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0404 13.7774V46.0371H34.1509V13.7774H41.0905V3.94385H22.0404V13.7774Z",
    fill: "#01000B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9804 3.94385H43.9399V13.7774H47.9804V3.94385Z",
    fill: "#01000B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 303,
    height: 50,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempusLogo);
export default __webpack_public_path__ + "static/media/tempusLogo.9f27c8870df3897919e3350d8e92924b.svg";
export { ForwardRef as ReactComponent };